export const platforms = [
  {
    id: 1,
    name: "樱花视频",
    slug: "yinghua-shipin",
    description: "樱花视频是国内领先的免费在线视频平台，拥有海量高清影视资源，涵盖电影、电视剧、综艺、动漫等多种类型。平台采用先进视频压缩技术，确保播放流畅不卡顿，支持手机、平板、电脑多端同步观看。每日更新最新热播内容，让用户第一时间享受精彩视频体验。",
    features: ["海量资源库", "高清流畅播放", "多端同步", "每日更新"],
    rating: 9.5,
    category: "综合平台",
    imageSeq: "platform-yinghua-01",
    siteUrl: "https://yinghua-video.com",
    color: "from-rose-500 to-orange-500",
  },
  {
    id: 2,
    name: "香蕉视频",
    slug: "xiangjiao-shipin",
    description: "香蕉视频以其丰富的电影资源和极速的播放体验著称。平台收录了国内外最新最热的电影大片，提供1080P超清画质，加载速度极快，几乎零缓冲。界面简洁直观，分类清晰，用户可以快速找到心仪的影片内容。",
    features: ["最新电影", "1080P超清", "极速加载", "简洁界面"],
    rating: 9.3,
    category: "电影专区",
    imageSeq: "platform-xiangjiao-01",
    siteUrl: "https://xiangjiao-video.com",
    color: "from-yellow-500 to-amber-600",
  },
  {
    id: 3,
    name: "红桃视频",
    slug: "hongtao-shipin",
    description: "红桃视频专注于精品电视剧和热门综艺内容，收录了大量经典国产剧、热门韩剧、美剧等优质资源。平台特色在于智能推荐算法，能根据用户观看历史精准推送感兴趣的内容，打造个性化观影体验。",
    features: ["精品剧集", "热门综艺", "智能推荐", "个性体验"],
    rating: 9.1,
    category: "电视剧集",
    imageSeq: "platform-hongtao-01",
    siteUrl: "https://hongtao-video.com",
    color: "from-red-500 to-pink-600",
  },
  {
    id: 4,
    name: "蜜桃视频",
    slug: "mitao-shipin",
    description: "蜜桃视频以优质的动漫番剧和纪录片内容见长。平台与多家内容制作方合作，拥有正版授权动漫资源，涵盖日漫、国漫、欧美动画等。同时提供高清纪录片频道，满足用户多元化的内容需求。",
    features: ["正版动漫", "纪录片频道", "多元内容", "高清画质"],
    rating: 9.0,
    category: "动漫专区",
    imageSeq: "platform-mitao-01",
    siteUrl: "https://mitao-video.com",
    color: "from-pink-400 to-rose-500",
  },
  {
    id: 5,
    name: "糖豆视频",
    slug: "tangdou-shipin",
    description: "糖豆视频主打短视频和微电影内容，为用户提供轻松愉快的碎片化观影体验。平台汇聚了海量搞笑短视频、创意微电影、生活Vlog等精彩内容，支持竖屏全屏播放，操作简单便捷，适合移动端用户随时观看。",
    features: ["短视频", "微电影", "竖屏播放", "移动优先"],
    rating: 8.8,
    category: "短视频",
    imageSeq: "platform-tangdou-01",
    siteUrl: "https://tangdou-video.com",
    color: "from-orange-400 to-red-500",
  },
  {
    id: 6,
    name: "星辰影院",
    slug: "xingchen-yingyuan",
    description: "星辰影院是一个新兴的综合视频平台，拥有丰富的国内外电影资源。平台界面设计优雅大方，提供多种画质选择，支持离线缓存功能。更新速度快，新片上映后短时间内即可在线观看。",
    features: ["新片速递", "离线缓存", "多画质选择", "优雅界面"],
    rating: 8.7,
    category: "综合平台",
    imageSeq: "platform-xingchen-01",
    siteUrl: "https://xingchen-cinema.com",
    color: "from-indigo-500 to-violet-600",
  },
  {
    id: 7,
    name: "蓝鲸影视",
    slug: "lanjing-yingshi",
    description: "蓝鲸影视以其庞大的电视剧资源库闻名，收录了超过两万部电视剧集。从经典老剧到最新热播剧应有尽有，是电视剧爱好者的天堂。平台提供全集打包观看功能，让追剧更加方便。",
    features: ["两万+剧集", "全集打包", "经典老剧", "追剧方便"],
    rating: 8.9,
    category: "电视剧集",
    imageSeq: "platform-lanjing-01",
    siteUrl: "https://lanjing-tv.com",
    color: "from-cyan-500 to-blue-600",
  },
  {
    id: 8,
    name: "极光动漫",
    slug: "jiguang-dongman",
    description: "极光动漫是专为二次元爱好者打造的动漫视频平台。平台日漫资源丰富，更新速度同步日本播出，同时拥有大量国产动漫资源。社区功能完善，用户可以发表弹幕互动，分享观影心得。",
    features: ["同步日漫", "国漫资源", "弹幕互动", "社区交流"],
    rating: 8.6,
    category: "动漫专区",
    imageSeq: "platform-jiguang-01",
    siteUrl: "https://jiguang-anime.com",
    color: "from-purple-500 to-fuchsia-600",
  },
];

export const topPlatforms = platforms.filter(p => [1, 2, 3, 4, 5].includes(p.id));